module.exports = __webpack_public_path__ + "media/industry_tag_icon/biz_realestate-aa347a94.png";